import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    id: 1,
    title: 'The Future of E-commerce: Trends to Watch in 2024',
    excerpt: 'Discover the latest trends shaping the future of online retail and how businesses can stay ahead of the curve.',
    author: 'John Doe',
    date: 'March 15, 2024',
    category: 'E-commerce',
    image: 'https://via.placeholder.com/800x400',
  },
  {
    id: 2,
    title: 'How Mobile Apps Are Transforming the Restaurant Industry',
    excerpt: 'Learn how mobile technology is revolutionizing the way restaurants operate and interact with customers.',
    author: 'Jane Smith',
    date: 'March 10, 2024',
    category: 'Restaurant Tech',
    image: 'https://via.placeholder.com/800x400',
  },
  {
    id: 3,
    title: 'The Benefits of Custom Software for Service Businesses',
    excerpt: 'Explore how custom software solutions can streamline operations and improve customer satisfaction.',
    author: 'Mike Johnson',
    date: 'March 5, 2024',
    category: 'Business Software',
    image: 'https://via.placeholder.com/800x400',
  },
  {
    id: 4,
    title: 'UI/UX Design Principles for Better User Engagement',
    excerpt: 'Master the key principles of user interface and experience design to create more engaging digital products.',
    author: 'Sarah Williams',
    date: 'March 1, 2024',
    category: 'Design',
    image: 'https://via.placeholder.com/800x400',
  },
];

const Blog = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary to-blue-700 text-white py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Our Blog
            </h1>
            <p className="text-xl mb-8">
              Insights, tips, and trends in web and mobile app development.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {blogPosts.map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="relative h-48 md:h-64">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-primary text-white px-4 py-1 rounded-full text-sm">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center text-gray-600 text-sm mb-4">
                    <span>{post.author}</span>
                    <span className="mx-2">•</span>
                    <span>{post.date}</span>
                  </div>
                  <h2 className="text-2xl font-bold mb-4">
                    <Link to="#" className="hover:text-primary">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-gray-600 mb-4">
                    {post.excerpt}
                  </p>
                  <Link
                    to="#"
                    className="text-primary hover:text-blue-700 font-semibold inline-flex items-center"
                  >
                    Read More
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">
              Subscribe to Our Newsletter
            </h2>
            <p className="text-gray-600 mb-8">
              Get the latest insights and tips delivered straight to your inbox.
            </p>
            <form className="flex flex-col md:flex-row gap-4 justify-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-6 py-3 rounded-full border border-gray-300 focus:ring-primary focus:border-primary flex-grow md:max-w-md"
              />
              <button
                type="submit"
                className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition duration-300"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog; 